/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { Injectable, signal } from '@angular/core';

export interface ActionSheetModalConfig {
  componentProps?: any;
  hasBackdrop?: boolean;
  disableClose?: boolean;
  panelClass?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ActionSheetModalService {
  modals = signal<ComponentType<any>[]>([]);

  currentOpenModal: DialogRef<any, ComponentType<any>> | null = null;

  constructor(private readonly dialog: Dialog) {}

  create<T = any>(
    component: ComponentType<any>,
    config?: ActionSheetModalConfig,
  ): DialogRef<T, ComponentType<any>> {
    this.currentOpenModal = this.dialog.open<T, unknown, ComponentType<any>>(
      component,
      {
        data: config?.componentProps,
        hasBackdrop: config?.hasBackdrop || false,
        disableClose: config?.disableClose || true,
        panelClass: config?.panelClass || 'action-sheet-modal',
      },
    );

    this.modals.update((modals) => [...modals, component]);

    this.currentOpenModal.closed.subscribe({
      next: () => {
        this.modals.update((modals) =>
          modals.filter((modal) => modal !== component),
        );
        this.currentOpenModal = null;
      },
    });

    return this.currentOpenModal;
  }

  close(result?: any) {
    if (this.currentOpenModal) {
      const element = this.getElement();

      if (element) {
        // 아래로 내려가는 애니메이션
        const closeAnimation = element.animate(
          [
            { opacity: 1, transform: 'translateY(0)' },
            { opacity: 0, transform: 'translateY(50px)' },
          ],
          {
            duration: 200,
            easing: 'ease-in-out',
          },
        );

        // 애니메이션이 끝난 후 모달을 닫고 상태 업데이트
        closeAnimation.onfinish = () => {
          this.currentOpenModal!.close(result);
          this.modals.update((modals) =>
            modals.filter(
              (modal) => modal !== this.currentOpenModal?.componentInstance,
            ),
          );
          this.currentOpenModal = null;
        };
      }
    }
  }

  getElement(): HTMLElement | null {
    const dialogs = document.querySelectorAll('cdk-dialog-container');
    const topId = dialogs.item(dialogs.length - 1)?.id;
    if (topId) {
      return document.getElementById(topId);
    }

    return null;
  }
}
